import type { MississippiCoverCorrectionsDto } from '../generated/dtos.gen';

const NO_CORRECTIONS: MississippiCoverCorrectionsDto = {
  role: null,
  nameOfFiler: null,
  address: null,
  cityZip: null,
  telephone: null,
  fax: null,
  contactOrTreasurer: null,
  email: null,
  officeSought: null,
  reportType: null,
  informationDiffers: null,
  jan1CashOnHand: null,
  contributionsItemized: null,
  contributionsNonItemized: null,
  contributionsThisPeriod: null,
  contributionsYearToDate: null,
  disbursementsItemized: null,
  disbursementsNonItemized: null,
  disbursementsThisPeriod: null,
  disbursementsYearToDate: null,
  endingCashOnHand: null,
  typedSignatureName: null,
  signingDate: null,
};

export function mississippiCoverCorrections(
  given: Partial<MississippiCoverCorrectionsDto> = {},
): MississippiCoverCorrectionsDto {
  return { ...NO_CORRECTIONS, ...given };
}
